import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "lucide-react"; // Import arrow icons
import './Rent.css'; // Import the CSS file
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../common/constant";

// Custom Previous Arrow
const PrevArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="absolute top-1/2 -left-6 transform -translate-y-1/2 cursor-pointer bg-[#54BD95] text-white p-2 rounded-full shadow-lg"
  >
    <ChevronLeft size={20} className="text-white " />
  </div>
);

// Custom Next Arrow
const NextArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="absolute top-1/2 -right-6 transform -translate-y-1/2 cursor-pointer bg-[#54BD95] text-white p-2 rounded-full shadow-lg"
  >
    <ChevronRight size={20} className="text-white" />
  </div>
);

const Rent_property = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]); // State to store fetched data
  const [loading, setLoading] = useState(true); // State to show loading

  const settings = {
    dots: false,
    infinite: true, // Infinite scrolling
    speed: 300,
    autoplay: true,
    slidesToShow: 4, // Show 4 cards at a time
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  // Fetch data from the API
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/society-rent/all-societies`);
        console.log("Fetched properties:", response.data.societies); // Log the data
        setProperties(response.data.societies); // Update state with fetched data
        setLoading(false); // Hide the loader
      } catch (error) {
        console.error("Error fetching properties:", error);
        setLoading(false); // Hide the loader in case of error
      }
    };

    fetchProperties();
  }, []);

  const handleNavigate = (id) => {
    navigate(`/for-rent-property/${id}`); // Navigate to a specific property
  };

  if (loading) {
    return ;
  }

  return (
    <>
      <h1  className="text-4xl  text-center mt-2 text-[#54BD95] mb-4">
      Best Societies for Rent in Lucknow
      </h1>
      <div className="text-end px-6 mx-14 mt-4">
        <Link to="/rent-list">
          <button className="px-4 py-2 bg-[#54BD95] text-white font-semibold rounded hover:bg-[#3a8f70] show_btn transition duration-200">
            Show More
          </button>
        </Link>
      </div>
      <div className="relative main-dev px-4 mx-16 mt-8">
        {properties.length > 1 ? (
          <Slider {...settings}>
            {properties.map((property) => (
              <div key={property._id} className="p-6">
                <div
                  className="bg-white shadow-lg rounded-lg overflow-hidden max-w-sm mx-auto cursor-pointer transition-transform transform hover:scale-105"
                  onClick={() => handleNavigate(property._id)}
                >
                  <img
                    src={`${API_URL}/uploads/societyRent/${property._id}/${property.mainImage}`}
                    alt={property.name}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h2 className="text-xl font-bold text-gray-800 mb-1">{property.name}</h2>
                    <p className="text-gray-600 text-sm mb-3">{`Rent price starting from ₹ ${property.one_bhk_rent}`}</p>

                    <div className="mt-3 flex flex-wrap gap-2">
                      {property.facilities?.slice(0, 3).map((facility, index) => (
                        <span
                          key={index}
                          className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full"
                        >
                          {facility}
                        </span>
                      ))}
                    </div>

                    <div className="mt-4">
                      <button className="w-full bg-[#54BD95] text-white font-semibold py-2 rounded-lg hover:bg-green">
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : properties.length === 1 ? (
          <div className="bg-white shadow-lg rounded-lg overflow-hidden max-w-sm mx-auto cursor-pointer transition-transform transform hover:scale-105"
            onClick={() => handleNavigate(properties[0]._id)}
          >
            <img
              src={`${API_URL}/uploads/societyRent/${properties[0]._id}/${properties[0].mainImage}`}
              alt={properties[0].name}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-bold text-gray-800 mb-1">{properties[0].name}</h2>
              <p className="text-gray-600 text-sm mb-3">{`Rent price starting from ₹ ${properties[0].one_bhk_rent}`}</p>

              <div className="mt-3 flex flex-wrap gap-2">
                {properties[0].facilities?.slice(0, 3).map((facility, index) => (
                  <span
                    key={index}
                    className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full"
                  >
                    {facility}
                  </span>
                ))}
              </div>

              <div className="mt-4">
                <button className="w-full bg-[#54BD95] text-white font-semibold py-2 rounded-lg hover:bg-green">
                  View Details
                </button>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-center text-lg text-gray-500 mt-6">No properties available for rent at the moment.</p>
        )}
      </div>

    </>
  );
};

export default Rent_property;
